<template>
  <div class="row py-4">
    <div class="col-lg-6 offset-lg-3 col-12 text-center">
      <div class="mb-4">
        <i class="fal fa-check-circle fa-7x text-success"></i>
      </div>
      <h3>
        {{ $t('message.booking.complete_step.booking_success') }}
      </h3>
      <div class="mt-4">
        <span v-html="$t('message.booking.complete_step.success_message01')"></span>
      </div>
      <div class="mt-3">
        <span v-html="$t('message.booking.complete_step.success_message02')"></span>
      </div>
      <div class="mt-3 text-info">
        <span v-html="$t('message.booking.complete_step.success_message03')"></span>
      </div>
      <div class="mt-4">
        <router-link :to="pageUrl" class="btn btn-info btn-block">
          {{ $t('message.booking.complete_step.view_my_booking') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import insiderHelpers from '../../helpers/insiderHelpers'

  export default {
    data () {
      return {
        pageUrl: null
      }
    },
    computed: {
      ...mapGetters({
        newOrderData: 'booking/getNewOrderData',
        user: 'auth/getUser'
      })
    },
    async mounted () {
      this.pageUrl = `/reservation/${this.newOrderData.id}`
      // Insider purchase event
      const params = {
        user: this.user,
        orderId: this.newOrderData.id
      }
      // Check package or subscription for counting order qty
      if (this.newOrderData.orderQty) {
        params.orderQty = this.newOrderData.orderQty
      }
      await insiderHelpers.purchaseEvent(params)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/booking/ThankYouPage.vue